import React from "react";
import "./index.scss";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";
import { MORE_GRAPH_OPTIONS_VITAL } from "../../common/constant/common-constants";
import { handleOutsideClick } from "../../common/utils/CommonUtils";
import SnakeCanvas from "../Chart/SnakeCanvas";


const hiddenAxisConfig = () => ({
    yAxis: { labels: { show: false }, line: { show: false } },
    xAxis: { labels: { show: false }, line: { show: false } },
});


const MonitorChartMobileView = ({
    secondvitalGraphName,
    setSecondVitalGraphName,
    secondMoreVitalECG,
    setSecondMoreVitalECG,
    dataRange,
    graphDrawerRef,
    canvasSize,
}) => {

    const handleSecondVitalECGSelect = (option) => {
        setSecondVitalGraphName(option);
        setSecondMoreVitalECG(false);
    };

    const handleSecondMoreVitalECG = (event) => {
        if (!secondMoreVitalECG) {
            handleOutsideClick(event, "vital-ecg-graph-2-mobile", setSecondMoreVitalECG);
        }
    };

    const onWindowSizeChange = (w, h) => {
        canvasSize.current = { width: w, height: h };
    };

    const onSymmetricalWindow = (key) => (min, max) => {
        if (min == null || max == null) return;
        const absMax = Math.max(Math.abs(min), Math.abs(max));
        const m = Math.ceil((absMax * 1.2) / 2) * 2 || 100;
        dataRange.current.current[key] = { min: -m, max: m };
    };

    const onCenteredWindow = (key) => (min, max) => {
        if (min == null || max == null) return;
        const center = (min + max) / 2;
        const halfRange = (max - min) / 2;
        const m = halfRange * 1.2 || 1;
        dataRange.current.current[key] = { min: center - m, max: center + m };
    };

    return (
        <div className="monitor-chart-mobile">
            <div className="monitor-chart-mobile-graph monitor-chart-mobile-ecg-1">
                <div className="monitor-chart-mobile-top-bar ecg-color">II</div>
                <div className="monitor-chart-mobile-canvas">
                    <SnakeCanvas
                        name="monitor-ecg-i-mobile"
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onSymmetricalWindow("ecgI")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.ecgI = d; }}
                        getDataRange={() => dataRange.current.current.ecgI}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="monitor-chart-mobile-graph monitor-chart-mobile-ecg-2">
                <div
                    className="monitor-chart-mobile-select-container"
                    onClick={(event) => handleSecondMoreVitalECG(event)}
                >
                    <div className="monitor-chart-mobile-selected-name ecg-color">
                        {secondvitalGraphName?.label}
                    </div>
                    {secondMoreVitalECG && (
                        <img className="monitor-chart-mobile-arrow" src={whiteUpArrow} alt="up" />
                    )}
                    {!secondMoreVitalECG && (
                        <img className="monitor-chart-mobile-arrow" src={whiteDownArrow} alt="down" />
                    )}
                    {secondMoreVitalECG && (
                        <div className="monitor-chart-mobile-options" id="vital-ecg-graph-2-mobile">
                            {MORE_GRAPH_OPTIONS_VITAL.MONITOR.map((option) => (
                                <div
                                    key={option.name}
                                    className={
                                        option.name === secondvitalGraphName?.name
                                            ? "monitor-chart-mobile-option monitor-chart-mobile-option-active"
                                            : "monitor-chart-mobile-option"
                                    }
                                    onClick={() => handleSecondVitalECGSelect(option)}
                                >
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="monitor-chart-mobile-canvas">
                    <SnakeCanvas
                        name={`monitor-ecg-ii-mobile-${secondvitalGraphName?.id}`}
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onSymmetricalWindow("ecgII")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.ecgII = d; }}
                        getDataRange={() => dataRange.current.current.ecgII}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="monitor-chart-mobile-graph monitor-chart-mobile-resp">
                <div className="monitor-chart-mobile-top-bar resp-color">Resp</div>
                <div className="monitor-chart-mobile-canvas">
                    <SnakeCanvas
                        name="monitor-resp-mobile"
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onSymmetricalWindow("resp")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.resp = d; }}
                        getDataRange={() => dataRange.current.current.resp}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="monitor-chart-mobile-graph monitor-chart-mobile-pleth">
                <div className="monitor-chart-mobile-top-bar pleth-color">Pleth</div>
                <div className="monitor-chart-mobile-canvas">
                    <SnakeCanvas
                        name="monitor-pleth-mobile"
                        nPointsPerWindow={1450}
                        headTailGapPx={50}
                        onWindowComplete={onCenteredWindow("pleth")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.pleth = d; }}
                        getDataRange={() => dataRange.current.current.pleth}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>
        </div>
    );
};

export default MonitorChartMobileView;
